<template>
  <van-swipe class="pi-order-swipe" @change="onChange" :loop="false" indicator-color="white">
    <van-swipe-item v-for="(item,index) in homeOrderList" :key="index">
      <template v-if="item.orderStatus == 0">
        <page-charging-launching v-if="current == index" :propOrderNo="item.orderNo"></page-charging-launching>
      </template>
      <template v-else-if="item.orderStatus == 1">
        <page-charging v-if="current == index" :propOrderNo="item.orderNo"></page-charging>
      </template>
      <template v-else-if="item.orderStatus == 2">
        <page-charging-finish v-if="current == index" :propOrderNo="item.orderNo"></page-charging-finish>
      </template>
      <template v-else-if="item.orderStatus == 5">
        <page-order-no-pay v-if="current == index" :propOrderNo="item.orderNo"></page-order-no-pay>
      </template>
    </van-swipe-item>
  </van-swipe>
</template>
<script>
import { Swipe, SwipeItem } from 'vant';
import pageCharging from '@/view/charge/charging/index';
import pageChargingFinish from '@/view/charge/finish/index';
import pageChargingLaunching from '@/view/charge/launching/index';
import orderNoPay from '@/view/charge/unpaid/charge-wait-pay';
export default {
  name: 'pi-order-swipe',
  data(){
    return {
      homeOrderList: [],
      current: 0,
      accountPkId: ''
    }
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    'page-charging': pageCharging,
    'page-charging-finish': pageChargingFinish,
    'page-charging-launching': pageChargingLaunching,
    'page-order-no-pay': orderNoPay,
  },
  methods: {
    onChange(index) {
      this.current = index;
      if(this.homeOrderList[index].orderStatus == 6){
        var orderNo = [];
        this.homeOrderList.map((item) => {
          orderNo.push(item.orderNo);
        });
        this.$router.replace({
          name: "my/order",
          query: {
            accountPkId: this.accountPkId,
            orderState: 2,
            userType: "",
            orderNo: orderNo,
            replace: true
          },
        });
      }
    },
  },
  mounted() {
    let homeOrderList = this.$common.get('homeOrderList');
    this.accountPkId = this.$route.query.accountPkId;
    if(homeOrderList){
      this.homeOrderList = homeOrderList;
      if(this.homeOrderList[0]){
        this.onChange(0);
      }
    }
  },
}
</script>
<style>
  .pi-order-swipe{
    height: 100%;
  }
  .my-swipe .van-swipe-item {
    color: #333;
    font-size: 20px;
    
    text-align: center;
    background-color: #ccc;
  }
</style>